// Live's drag of Library cards onto a project tile (spec library-card-drag): what a drag carries,
// and when a tile refuses it. A browser shows a drag's data only at its drop, so the screen keeps
// the drag under way (live's transfer store) for the tiles to read as it passes over them.
import type { DragEvent } from "react";

import type { Asset } from "../../api/generated/model";

/** The drag's own type, which the page's file drop and the window's stray-drop guard pass by. */
export const CARD_DRAG = "application/x-createdai-assets";

/** The files a drag carries, and the folders they are in (null: the brand's top level). */
export interface CardDrag {
  assetIds: readonly string[];
  folderIds: ReadonlySet<string | null>;
}

export function cardDragOf(assets: readonly Asset[]): CardDrag {
  return {
    assetIds: assets.map((asset) => asset.id),
    folderIds: new Set(assets.map((asset) => asset.folder_id)),
  };
}

/** A card's drag begins: it carries its files, to be moved. */
export function startCardDrag(event: DragEvent, drag: CardDrag): void {
  event.dataTransfer.setData(CARD_DRAG, JSON.stringify(drag.assetIds));
  event.dataTransfer.effectAllowed = "move";
}

/**
 * The drag is a card's. A dragged picture also carries its file in some browsers, so a page that
 * takes dropped files asks this first.
 */
export function isCardDrag(event: DragEvent): boolean {
  return event.dataTransfer.types.includes(CARD_DRAG);
}

/** Every file is in the folder already: live's tile refuses the drop, which would move nothing. */
export function allIn(drag: CardDrag, folderId: string): boolean {
  return drag.folderIds.size === 1 && drag.folderIds.has(folderId);
}
